/** A clip as something the browser plays. */
export async function clipUri(
  _key: string,
  mime: 'audio/mpeg' | 'audio/wav',
  audio: string,
): Promise<{ uri: string; dispose: () => void }> {
  return { uri: `data:${mime};base64,${audio}`, dispose: () => {} };
}
